import Minus from './types/minus'

// module.exports = {
// 	Minus,
// }
export default Minus